import styles from './journey.module.css';

interface IndicatorProps {
  /** Checkboxes get a rounded square; radios get a circle. */
  shape: 'circle' | 'square';
}

/** The tick / dot inside a selected option row. Purely decorative. */
export function Indicator({ shape }: IndicatorProps) {
  return (
    <span
      className={`${styles.optionIndicator} ${
        shape === 'square' ? styles.optionIndicatorSquare : ''
      }`}
      aria-hidden="true"
    >
      <svg
        className={styles.optionIndicatorGlyph}
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M2.5 6.2 4.8 8.5 9.5 3.8"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
